/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconStarFilled8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconStarFilled8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M5.74 4.78 7.5 3.06l-.05-.16-2.433-.353L3.92.333h-.166l-1.09 2.21L.22 2.9l-.053.16L1.93 4.78l-.413 2.433.137.097 2.18-1.143 2.18 1.143.136-.096-.416-2.427.006-.007Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconStarFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconStarFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="m8.61 7.17 2.64-2.58-.075-.24-3.65-.53L5.88.5h-.25L3.995 3.815.33 4.35l-.08.24 2.645 2.58-.62 3.65.205.145L5.75 9.25l3.27 1.715.205-.145L8.6 7.18l.01-.01Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconStarFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconStarFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M11.48 9.56 15 6.12l-.1-.32-4.867-.707L7.84.667h-.334l-2.18 4.42L.44 5.8l-.107.32L3.86 9.56l-.827 4.867.273.193 4.36-2.287 4.36 2.287.274-.193-.834-4.854.014-.013Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconStarFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconStarFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="m17.22 14.34 5.28-5.16-.15-.48-7.3-1.06L11.76 1h-.5L7.99 7.63.66 8.7l-.16.48 5.29 5.16-1.24 7.3.41.29 6.54-3.43 6.54 3.43.41-.29-1.25-7.28.02-.02Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconStarFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconStarFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconStarFilled8 {...iconProps} />;
        case '12':
            return <IconStarFilled12 {...iconProps} />;
        case '16':
            return <IconStarFilled16 {...iconProps} />;
        case '24':
            return <IconStarFilled24 {...iconProps} />;
        default:
            return <IconStarFilled24 {...iconProps} />;
    }
});
